import * as React from 'react'
import { FC, useEffect, useState, useCallback } from 'react'
import './Dropdown.scss'
import { Pill } from './Pills'
import { ArrowDown, Close } from '../../../Icons'

interface Props {
    items?: Pill[]
    activeSection?: string
    onClick?: (slug: string) => void
}

const Dropdown: FC<Props> = ({ items = [], activeSection = '', onClick }) => {
    const [currentLabel, setCurrentLabel] = useState('')
    const [showDropdown, setShowDropdown] = useState(false)

    const onClickHandle = useCallback(
        (slug: string) => {
            setShowDropdown(false)
            onClick?.(slug)
        },
        [onClick]
    )

    useEffect(() => {
        const filteredItem = items.filter((item) => item.slug === activeSection)[0]
        filteredItem && setCurrentLabel(filteredItem.label)
    }, [activeSection, items])

    return (
        <div className="Dropdown">
            <div className="Dropdown__title" onClick={() => setShowDropdown(true)}>
                <div className="Dropdown__label">
                    <p>{currentLabel}</p>
                </div>
                <div className="Dropdown__icon">{showDropdown ? <Close /> : <ArrowDown />}</div>
            </div>
            {showDropdown && (
                <ul className="Dropdown__list">
                    {items.map(({ label, slug }, index) => (
                        <li className={activeSection === slug ? 'active' : ''} key={index}>
                            <a href={`#${slug}`} onClick={() => onClickHandle(slug)}>
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default Dropdown
